module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNNi4wMjQ3NyA1LjQzMjA1TDEwLjk2MyAwLjQ5Mzg2NkwxMiAxLjUzMDkxTDYuMDI0NzUgNy41MDYxNkwwIDEuNTMwOTFMMS4wMzcwNCAwLjQ5Mzg2NiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/angle-arrow-down.svg
// module id = nxcL
// module chunks = 1